export var AnnualDiscountKind;
(function (AnnualDiscountKind) {
    AnnualDiscountKind["Percent"] = "PERCENT";
    AnnualDiscountKind["Period"] = "PERIOD";
})(AnnualDiscountKind || (AnnualDiscountKind = {}));
export var BusinessSegment;
(function (BusinessSegment) {
    BusinessSegment["Events"] = "EVENTS";
    BusinessSegment["Retail"] = "RETAIL";
})(BusinessSegment || (BusinessSegment = {}));
export var CurationMatchMode;
(function (CurationMatchMode) {
    CurationMatchMode["Product"] = "PRODUCT";
    CurationMatchMode["Variant"] = "VARIANT";
})(CurationMatchMode || (CurationMatchMode = {}));
export var CurationStatus;
(function (CurationStatus) {
    CurationStatus["Approved"] = "APPROVED";
    CurationStatus["Flagged"] = "FLAGGED";
    CurationStatus["Proposed"] = "PROPOSED";
})(CurationStatus || (CurationStatus = {}));
export var DeliveryStrategy;
(function (DeliveryStrategy) {
    DeliveryStrategy["Annual"] = "ANNUAL";
    DeliveryStrategy["Biweekly"] = "BIWEEKLY";
    DeliveryStrategy["Custom"] = "CUSTOM";
    DeliveryStrategy["Immediately"] = "IMMEDIATELY";
    DeliveryStrategy["Monthly"] = "MONTHLY";
    DeliveryStrategy["Once"] = "ONCE";
    DeliveryStrategy["Quarterly"] = "QUARTERLY";
    DeliveryStrategy["Weekly"] = "WEEKLY";
})(DeliveryStrategy || (DeliveryStrategy = {}));
export var DiscountPlatform;
(function (DiscountPlatform) {
    DiscountPlatform["Eventbrite"] = "EVENTBRITE";
    DiscountPlatform["Shopify"] = "SHOPIFY";
    DiscountPlatform["Square"] = "SQUARE";
})(DiscountPlatform || (DiscountPlatform = {}));
export var DiscountScope;
(function (DiscountScope) {
    DiscountScope["Event"] = "EVENT";
    DiscountScope["Retail"] = "RETAIL";
})(DiscountScope || (DiscountScope = {}));
export var FulfillmentInvoiceStatus;
(function (FulfillmentInvoiceStatus) {
    FulfillmentInvoiceStatus["Draft"] = "DRAFT";
    FulfillmentInvoiceStatus["Finalized"] = "FINALIZED";
    FulfillmentInvoiceStatus["Paid"] = "PAID";
})(FulfillmentInvoiceStatus || (FulfillmentInvoiceStatus = {}));
export var MembershipCancellationReason;
(function (MembershipCancellationReason) {
    MembershipCancellationReason["ByOrganizer"] = "By_Organizer";
    MembershipCancellationReason["DidNotUse"] = "Did_Not_Use";
    MembershipCancellationReason["HardToUse"] = "Hard_To_Use";
    MembershipCancellationReason["LifeIsHard"] = "Life_Is_Hard";
    MembershipCancellationReason["Other"] = "Other";
})(MembershipCancellationReason || (MembershipCancellationReason = {}));
export var MembershipKind;
(function (MembershipKind) {
    MembershipKind["Friend"] = "Friend";
    MembershipKind["Honorary"] = "Honorary";
    MembershipKind["Legacy"] = "Legacy";
    MembershipKind["Live"] = "Live";
    MembershipKind["Retired"] = "Retired";
})(MembershipKind || (MembershipKind = {}));
export var MembershipStatus;
(function (MembershipStatus) {
    MembershipStatus["Active"] = "Active";
    MembershipStatus["Cancelled"] = "Cancelled";
    MembershipStatus["Ended"] = "Ended";
    MembershipStatus["New"] = "New";
})(MembershipStatus || (MembershipStatus = {}));
export var MoneyFormat;
(function (MoneyFormat) {
    MoneyFormat["Presentment"] = "Presentment";
    MoneyFormat["Shop"] = "Shop";
})(MoneyFormat || (MoneyFormat = {}));
export var Ordering;
(function (Ordering) {
    Ordering["Asc"] = "ASC";
    Ordering["Desc"] = "DESC";
})(Ordering || (Ordering = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Charged"] = "CHARGED";
    PaymentStatus["Completed"] = "COMPLETED";
    PaymentStatus["Failed"] = "FAILED";
    PaymentStatus["Finalized"] = "FINALIZED";
    PaymentStatus["Ignore"] = "IGNORE";
    PaymentStatus["ItemCharged"] = "ITEM_CHARGED";
    PaymentStatus["MembershipCharged"] = "MEMBERSHIP_CHARGED";
    PaymentStatus["New"] = "NEW";
    PaymentStatus["OffPlatform"] = "OFF_PLATFORM";
    PaymentStatus["Refunded"] = "REFUNDED";
})(PaymentStatus || (PaymentStatus = {}));
export var Period;
(function (Period) {
    Period["Day"] = "DAY";
    Period["Month"] = "MONTH";
    Period["Week"] = "WEEK";
    Period["Year"] = "YEAR";
})(Period || (Period = {}));
export var PlanKind;
(function (PlanKind) {
    PlanKind["Annual"] = "ANNUAL";
    PlanKind["Monthly"] = "MONTHLY";
    PlanKind["Weekly"] = "WEEKLY";
})(PlanKind || (PlanKind = {}));
export var PlatformIdKind;
(function (PlatformIdKind) {
    PlatformIdKind["DraftOrder"] = "DraftOrder";
    PlatformIdKind["Order"] = "Order";
})(PlatformIdKind || (PlatformIdKind = {}));
export var PlatformMode;
(function (PlatformMode) {
    PlatformMode["InStore"] = "IN_STORE";
    PlatformMode["Online"] = "ONLINE";
})(PlatformMode || (PlatformMode = {}));
export var PlatformName;
(function (PlatformName) {
    PlatformName["Clover"] = "CLOVER";
    PlatformName["Direct"] = "DIRECT";
    PlatformName["Eventbrite"] = "EVENTBRITE";
    PlatformName["Other"] = "OTHER";
    PlatformName["Shopify"] = "SHOPIFY";
    PlatformName["Square"] = "SQUARE";
    PlatformName["Squarespace"] = "SQUARESPACE";
    PlatformName["Toast"] = "TOAST";
})(PlatformName || (PlatformName = {}));
export var TransactionKind;
(function (TransactionKind) {
    TransactionKind["Addon"] = "Addon";
    TransactionKind["Base"] = "Base";
})(TransactionKind || (TransactionKind = {}));
export var VideoPlatform;
(function (VideoPlatform) {
    VideoPlatform["Vimeo"] = "VIMEO";
    VideoPlatform["Youtube"] = "YOUTUBE";
})(VideoPlatform || (VideoPlatform = {}));
